<template>
  <div>
    <Navbar></Navbar>
    <DocumentListBody></DocumentListBody>
  </div>
</template>

<script>
import Navbar from './Navbar.vue';
import DocumentListBody from './DocumentListBody.vue';

export default {
  name: 'DocumentList',
  components: {
    Navbar,
    DocumentListBody,
  },
};
</script>

<style>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.sign-out {
  width: 160px;
  margin: 0 auto;
}
</style>
